/* Ansichtszustand einer Liste: Positionsfilter, Sortierung, Richtung der Alterssortierung.
 *
 * Je Seite eine eigene Instanz (usePlayers.js legt eine für die Kaderseite und eine für die
 * Transfers-Seite an) — die Auswahl der einen Seite beeinflusst die andere nicht und bleibt beim
 * Seitenwechsel erhalten. Nur im Speicher, nicht dauerhaft gemerkt.
 */

import { ref } from 'vue';
import { DEFAULT_AGE_DIRECTION } from '../domain/squadFilter.js';
import { AGE_GROUP_ALL } from '../domain/ageGroups.js';

export function createListView() {
  return {
    positionFilter: ref('all'), // 'all' | 'st' | 'wing' | 'mid' | 'def' | 'gk'
    sortMode: ref('position'), // 'position' | 'az' | 'age' (Transfers zusätzlich 'date')
    ageDirection: ref(DEFAULT_AGE_DIRECTION), // 'youngest' | 'oldest'
    ageGroupFilter: ref(AGE_GROUP_ALL), // 'all' | 'U17' | 'U19'
  };
}
